import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Response } from '@ui/src';
import { purposeCodesApi } from '../services/purpose-codes';
import { PurposeCodeSettings } from '../../types';

export interface PurposeCodeSettingsState {
  purposeCodesSettings?: PurposeCodeSettings[];
  purposeCodesSetting?: PurposeCodeSettings;
}

const initialState: PurposeCodeSettingsState = {};

export const purposeCodeSettingsSlice = createSlice({
  name: 'purposeCodeSettings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      purposeCodesApi.endpoints.getPurposeCodesSettings.matchFulfilled,
      (state, action: PayloadAction<Response<PurposeCodeSettings>>) => {
        state.purposeCodesSettings = action?.payload?.data?.edges?.map(
          (item) => item.node,
        );
      },
    );
    builder.addMatcher(
      purposeCodesApi.endpoints.getPurposeCodesSettingsById.matchFulfilled,
      (state, action: PayloadAction<{ data: PurposeCodeSettings }>) => {
        state.purposeCodesSetting = action.payload.data;
      },
    );
    builder.addMatcher(
      purposeCodesApi.endpoints.deletePurposeCodeSetting.matchFulfilled,
      (state, action: PayloadAction<{ data: PurposeCodeSettings }>) => {
        state.purposeCodesSettings = state.purposeCodesSettings?.filter(
          (item) => item.id !== action.payload.data.id,
        );
      },
    );
    builder.addMatcher(
      purposeCodesApi.endpoints.createPurposeCodeSetting.matchFulfilled,
      (state, action: PayloadAction<{ data: PurposeCodeSettings }>) => {
        const nextPurposeCodeSettings = ([] as PurposeCodeSettings[]).concat(
          state.purposeCodesSettings as PurposeCodeSettings[],
        );

        nextPurposeCodeSettings.push(action.payload.data);

        state.purposeCodesSettings = nextPurposeCodeSettings;
      },
    );
    builder.addMatcher(
      purposeCodesApi.endpoints.updatePurposeCodeSetting.matchFulfilled,
      (state, action: PayloadAction<{ data: PurposeCodeSettings }>) => {
        state.purposeCodesSettings = state.purposeCodesSettings?.map((item) => {
          let result = { ...item };

          if (result.id === action?.payload?.data?.id) {
            result = action.payload.data;
          }

          return result;
        });
      },
    );
  },
});

export default purposeCodeSettingsSlice.reducer;
